import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getActiveTabFromLocalStorage } from "@/ui/TabsComponent/TabsComponent";

import { Page } from "@/ui/Layout/Page";
import { TabsComponent } from "@/ui/TabsComponent";
import Button from "@/ui/Button";
import { ButtonTypes, Variants } from "@/ui/types";
import { DashboardPage } from "@/Apps/Dashboards/DashboardPage";
import { getCampaign } from "@/api/campaigns";
import { Settings } from "@/Apps/Dashboards/Settings/Settings";
import { getSessionToken } from "@/api/auth";
import { PublishCampaignModal } from "../Funnels/Popups/PublishCampaignModal";
import { AutomationBuilder } from "../Workflows/widgets/AutomationBuilder";
import { ContentDashboardPage } from "./ContentDashboardPage";

import { ContactsGallery } from "@/Apps/CRM/ContactsGallery";
import { getFilterObject } from "@/Apps/CRM/scripts";

export const Dashboard = ({ name = "" }) => {
  const [activeTab, setActiveTab] = useState(getActiveTabFromLocalStorage() || "overview");
  const [membershipSite, setMembershipSiteData] = useState<{ name?: string }>({
    name: "",
  });
  const [isPublishPopupOpen, setIsPublishPopupOpen] = useState(false);
  // const [activePageId, setActivePageId] = useState(null);
  const { id } = useParams();

  // Fetch the campaign data from the API when the component mounts
  useEffect(() => {
    const token = getSessionToken();

    (async () => {
      const data = await getCampaign({ token, id });
      setMembershipSiteData(data);
    })();
  }, []);

  // Use this to configure what shows in the top bar of the page
  const topBarSettings = {
    page: [
      { label: name, href: "/member" },
      { label: membershipSite.name || "" },
    ],
    items: (
      <Button
        label="Publish Membership Site"
        onClick={() => setIsPublishPopupOpen(true)}
        type={ButtonTypes.OUTLINED}
        variant={Variants.INFO}
      />
    ),
  };

  return (
    <Page topBar={topBarSettings}>
      {/* Render the publish campaign modal if it's set to open */}
      {isPublishPopupOpen && (
        <PublishCampaignModal
          setIsOpen={setIsPublishPopupOpen}
          campaignId={id}
          unitName="Membership Site"
        />
      )}
      <div className={`p-6 w-full`}>
        <div className="tabs flex flex-col">
          <TabsComponent
            tabs={[
              { label: "Dashboard", value: "overview" },
              { label: "Content", value: "content" },
              { label: "Customize", value: "customize" },
              { label: "Media Assets", value: "media" },
              { label: "Automation", value: "automation" },
              { label: "Members", value: "crm" },
              { label: "Settings", value: "settings" },
            ]}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            actionSection={false}
          />
          {activeTab === "overview" && (
            <DashboardPage
              campaignData={membershipSite}
              unitName="post"
              panelTitle="Content"
              // widgets={["details", "kpi"]}
              widgets={[
                "details",
                {
                  type: "columns",
                  settings: {
                    widgets: [
                      "posts",
                      {
                        type: "group",
                        settings: { widgets: ["contactList", "media"] },
                      },
                    ],
                  },
                },
              ]}
            />
          )}
          {activeTab === "content" && (
            <ContentDashboardPage
              campaignData={membershipSite}
              unitName="post"
            />
          )}
          {activeTab === "customize" && (
            <DashboardPage
              campaignData={membershipSite}
              unitName="Membership Site"
              widgets={["customize"]}
            />
          )}
          {activeTab === "media" && (
            <DashboardPage
              campaignData={membershipSite}
              unitName="Membership Site"
              widgets={["media"]}
            />
          )}
          {activeTab === "automation" && <AutomationBuilder />}
          {activeTab === "crm" && (
            <ContactsGallery
              onCreate={() => {}}
              defaultFilter={getFilterObject({
                field: "hiddenTags",
                operator: "contains",
                value: id,
              })}
            />
          )}
          {activeTab === "settings" && (
            <Settings
              campaignData={membershipSite}
              setCampaignData={setMembershipSiteData}
              unitName="Membership Site"
              widgets={["name", "password", "share", "domain", "delete"]}
            />
          )}
        </div>
      </div>
    </Page>
  );
};
